@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package com.essntl.essntl_common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainFont0 {
  public val Manrope_Bold: FontResource by 
      lazy { init_Manrope_Bold() }

  public val Manrope_ExtraBold: FontResource by 
      lazy { init_Manrope_ExtraBold() }

  public val Manrope_ExtraLight: FontResource by 
      lazy { init_Manrope_ExtraLight() }

  public val Manrope_Light: FontResource by 
      lazy { init_Manrope_Light() }

  public val Manrope_Medium: FontResource by 
      lazy { init_Manrope_Medium() }

  public val Manrope_Regular: FontResource by 
      lazy { init_Manrope_Regular() }

  public val Manrope_SemiBold: FontResource by 
      lazy { init_Manrope_SemiBold() }
}

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("Manrope_Bold", CommonMainFont0.Manrope_Bold)
  map.put("Manrope_ExtraBold", CommonMainFont0.Manrope_ExtraBold)
  map.put("Manrope_ExtraLight", CommonMainFont0.Manrope_ExtraLight)
  map.put("Manrope_Light", CommonMainFont0.Manrope_Light)
  map.put("Manrope_Medium", CommonMainFont0.Manrope_Medium)
  map.put("Manrope_Regular", CommonMainFont0.Manrope_Regular)
  map.put("Manrope_SemiBold", CommonMainFont0.Manrope_SemiBold)
}

internal val Res.font.Manrope_Bold: FontResource
  get() = CommonMainFont0.Manrope_Bold

private fun init_Manrope_Bold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Manrope_Bold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/font/Manrope-Bold.ttf", -1, -1),
    )
)

internal val Res.font.Manrope_ExtraBold: FontResource
  get() = CommonMainFont0.Manrope_ExtraBold

private fun init_Manrope_ExtraBold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Manrope_ExtraBold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/font/Manrope-ExtraBold.ttf", -1, -1),
    )
)

internal val Res.font.Manrope_ExtraLight: FontResource
  get() = CommonMainFont0.Manrope_ExtraLight

private fun init_Manrope_ExtraLight(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Manrope_ExtraLight",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/font/Manrope-ExtraLight.ttf", -1, -1),
    )
)

internal val Res.font.Manrope_Light: FontResource
  get() = CommonMainFont0.Manrope_Light

private fun init_Manrope_Light(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Manrope_Light",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/font/Manrope-Light.ttf", -1, -1),
    )
)

internal val Res.font.Manrope_Medium: FontResource
  get() = CommonMainFont0.Manrope_Medium

private fun init_Manrope_Medium(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Manrope_Medium",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/font/Manrope-Medium.ttf", -1, -1),
    )
)

internal val Res.font.Manrope_Regular: FontResource
  get() = CommonMainFont0.Manrope_Regular

private fun init_Manrope_Regular(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Manrope_Regular",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/font/Manrope-Regular.ttf", -1, -1),
    )
)

internal val Res.font.Manrope_SemiBold: FontResource
  get() = CommonMainFont0.Manrope_SemiBold

private fun init_Manrope_SemiBold(): FontResource = org.jetbrains.compose.resources.FontResource(
  "font:Manrope_SemiBold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/font/Manrope-SemiBold.ttf", -1, -1),
    )
)
